<template>
  <div class="container has-text-centered">
    <h1 class="title custom-text-dark custom-heading">
      ChordPro
    </h1>
    <h2 class="subtitle custom-text-dark custom-regular-text">
      The automatic chord progression generator
    </h2>
  </div>
</template>

<script>
export default {
  name: "Heading",
};
</script>

<style>
.custom-text-dark {
  color: #494949;
  font-family: "Montserrat Alternates";
}
.custom-heading {
  font-weight: 900;
}
.custom-regular-text {
  font-weight: 300;
}
</style>
